import React, { useCallback, useState, useRef } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { GridLayout } from "../../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import {
  Column,
  DataGrid,
  Toolbar as GridToolbar,
  Item as GridToolbarItem,
} from "devextreme-react/data-grid";
const BlankLocationsGrid = (props) => {
  const dataGrid = useRef(null);

  return (
    <div>
      <div className="row">
        <div className="col-md-12 main-page">
          <div id="accordion" >
            <b> Blank Location Records Exist For This Transactions. Please Correct Your Location Data Before Proceeding. If this is Not Required, Change the Data Profile For No Validation. </b>
            <div>
              <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.dataSource}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                columnAutoWidth={true}
                onCellPrepared={(e) => {
                  if (e.rowType === 'data' && e.column.dataField === 'ErrorMessage') {
                    if (e.value) {
                      e.cellElement.style.color = 'red';
                    }
                  }
                }}
              >
                <Column dataField="ItemCode" caption="Item" dataType="string" />
                <Column dataField="LotCode" caption="Lot" dataType="string" />
                <Column dataField="SubLotCode" caption="SubLot" dataType="string" />
                <Column dataField="ErrorMessage" caption="Reason" dataType="string" />
              </DataGrid>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    oidc: state.oidc
  };
}
export default connect(mapStateToProps)(BlankLocationsGrid);